import { createReducer, on } from '@ngrx/store';
import { SettingsServiceLoadResponseJson } from '@vmspdb/definitions';
import { SettingsFilters } from './settings-filters';
import * as SettingsActions from './settings.actions';

export const settingsFeatureKey = 'settings';

export interface State {
  default: SettingsServiceLoadResponseJson;
  loaded: boolean;
  filters: SettingsFilters;
  loadError?: any;
}

export const initialState: State = {
  default: {},
  loaded: false,
  filters: {
    showOnlyCurrentEmployee: false,
  },
};

export const reducer = createReducer(
  initialState,
  on(SettingsActions.syncSearch, (state): State => state),
  on(SettingsActions.loadSettings, (state): State => state),
  on(SettingsActions.saveDropboxSettings, (state): State => state),
  on(SettingsActions.saveProjectPermitSettings, (state): State => state),
  on(SettingsActions.saveProjectSurveySettings, (state): State => state),
  on(SettingsActions.loadSettingsSuccess, (state, { settings }): State => ({
    ...state,
    default: settings,
    loaded: true,
    loadError: undefined,
  })),
  on(SettingsActions.loadSettingsFailure, (_state, { error }): State => ({
    ...initialState,
    loaded: true,
    loadError: error,
  })),
  on(SettingsActions.updateFilterSettings, (state, { filters }): State => ({
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
  })),
);
